/** Prompt chips for recipe detail and cook-mode agent entry points. */

export const RECIPE_DETAIL_ASK_PROMPTS = [
  'How can I adjust for missing ingredients?',
  'What can I prep ahead of time?',
  'What ingredients are most important?',
]

export const RECIPE_COOK_ASK_PROMPTS = [
  'Can I substitute an ingredient?',
  'How do I know it\'s done?',
  'What goes well as a side?',
]

/** Opens the app chat drawer with recipe context (handled in App.jsx). */
export function dispatchRecipeAskQuestion(question, recipeTitle = '', recipeId = '', surface = '') {
  if (typeof window === 'undefined' || !question?.trim()) return
  const askSurface = surface === 'cook' || surface === 'detail' ? surface : ''
  window.dispatchEvent(new CustomEvent('cookAskQuestion', {
    detail: {
      question: question.trim(),
      recipeTitle: recipeTitle ?? '',
      recipeId: recipeId ?? '',
      ...(askSurface ? { surface: askSurface } : {}),
    },
  }))
}

/** Message sent to the agent when a recipe-scoped prompt is chosen. */
export function formatRecipeAskMessage(question, recipeTitle, recipeId = '') {
  const q = String(question || '').trim()
  const title = String(recipeTitle || '').trim()
  const id = String(recipeId || '').trim()
  if (!title && !id) return q
  if (title && id) return `For my recipe "${title}" [INTERNAL_ID:${id}]: ${q}`
  if (id) return `For my recipe [INTERNAL_ID:${id}]: ${q}`
  return `For my recipe "${title}": ${q}`
}
